module.exports = __webpack_public_path__ + "static/media/sleepless-elite.4ca2a621.png";